import { AxiosError, AxiosResponse } from "axios";
import { IUpdateAnalystData } from "../../interfaces/IAnalyst";
import protheusProvider from "../providers/protheus.provider";

export class AnalystService {
  public async index(token: string): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.get('WSRESTANALISTA/coordenador', {
        params: {
          token
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async updateAnalyst(token: string, id: string, data: IUpdateAnalystData): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.put('WSRESTANALISTA/analista', {
        token,
        id,
        data
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }
}